module.exports = __webpack_public_path__ + "assets/7585b0efdd0a31059e474b04a240f7d1.png";